var _path, _rect, _path2, _rect2, _rect3, _path3, _rect4, _rect5, _path4, _rect6, _rect7, _path5, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupOrganization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6616 14.5L12.1616 12M9.66162 9.5L12.1616 12M12.1616 12L14.6616 9.5L9.33838 14.5",
    stroke: "#3B3E66"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 2.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    fill: "#3B3E66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6V4.625L16 4L17 4.625V6H15ZM18 6V4.625L19 4L20 4.625V6H18ZM18 7.625V9H20V7.625L19 7L18 7.625ZM15 9V7.625L16 7L17 7.625V9H15Z",
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 2.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    stroke: "#3B3E66",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 13.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    fill: "#3B3E66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 17V15.625L16 15L17 15.625V17H15ZM18 17V15.625L19 15L20 15.625V17H18ZM18 18.625V20H20V18.625L19 18L18 18.625ZM15 20V18.625L16 18L17 18.625V20H15Z",
    fill: "#F5F5F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 13.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    stroke: "#3B3E66",
    strokeWidth: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    fill: "#3B3E66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6V4.625L5 4L6 4.625V6H4ZM7 6V4.625L8 4L9 4.625V6H7ZM7 7.625V9H9V7.625L8 7L7 7.625ZM4 9V7.625L5 7L6 7.625V9H4Z",
    fill: "#F5F5F5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 2.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    stroke: "#3B3E66",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 13.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    fill: "#3B3E66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 17V15.625L5 15L6 15.625V17H4ZM7 17V15.625L8 15L9 15.625V17H7ZM7 18.625V20H9V18.625L8 18L7 18.625ZM4 20V18.625L5 18L6 18.625V20H4Z",
    fill: "#F5F5F5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 13.75,
    width: 7.5,
    height: 7.5,
    rx: 1.25,
    stroke: "#3B3E66",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupOrganization);
export default __webpack_public_path__ + "static/media/GroupOrganization.e69fa4dd161029f7ed364ff25b0b4e19.svg";
export { ForwardRef as ReactComponent };